import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  extraMargin: {
    marginBottom: "13px",
  },
}));

export default useStyles;
